import React, { useState } from 'react';
import { Page, Header, Content } from '@backstage/core-components';
import { Button, Typography, Box } from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

interface IFramePageProps {
  src: string;
  title?: string;
  height?: string;
}

export const IFramePage = ({ src, title = 'IFrame', height = '100vh' }: IFramePageProps) => {
  const directUrl = src.replace('/api/proxy/grafana', 'https://g-8e977d52f3.grafana-workspace.us-east-1.amazonaws.com');
  
  if (!src) {
    return (
      <Page themeId="tool">
        <Header title={title} />
        <Content>
          <div>Error: No src provided to IFramePage component</div>
        </Content>
      </Page>
    );
  }

  // AWS Managed Grafana blocks iframe embedding, so show direct access option
  return (
    <Page themeId="tool">
      <Header title={title} />
      <Content>
        <Box textAlign="center" mt={4}>
          <Typography variant="h4" gutterBottom color="primary">
            AWS Managed Grafana Access
          </Typography>
          <Typography variant="body1" paragraph style={{ maxWidth: '600px', margin: '0 auto 24px' }}>
            AWS Managed Grafana has security policies that prevent iframe embedding. 
            For the best experience and full functionality, please access Grafana directly.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<OpenInNewIcon />}
            href={directUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginBottom: '16px' }}
          >
            Open Grafana Dashboard
          </Button>
          <Box mt={3}>
            <Typography variant="body2" color="textSecondary">
              This will open in a new tab with full Grafana functionality
            </Typography>
          </Box>
        </Box>
      </Content>
    </Page>
  );
};